import { toast } from "react-toastify";
import { TKIconNotification } from "assets/images/svgs";
import TKModal from "./Modal";

const RequestConfirmation = ({ isOpen, onClose, text }) => {
  return (
    <TKModal open={isOpen} onClose={onClose}>
      <div className="bg-white max-sm:w-3/5 p-4 px-8 flex justify-center items-center">
        <div className="flex flex-col gap-4 justify-center items-center">
          <TKIconNotification />
          <p className="text-[16px] text-center text-[#7A7A7A]">{text}</p>
          <div className="flex justify-between gap-4">
            <p
              onClick={() => {
                toast.success("An email has been successfully sent!");
                onClose();
              }}
              className="cursor-pointer py-4  px-6 border border-[#07593D] text-[#07593D] hover:bg-[#07593D] hover:text-white"
            >
              Yes
            </p>
            <p
              onClick={onClose}
              className="cursor-pointer py-4  px-6 border border-[#EE0816] text-[#EE0816] hover:bg-[#EE0816] hover:text-white"
            >
              No
            </p>
          </div>
        </div>
      </div>
    </TKModal>
  );
};

export default RequestConfirmation;
